<div class="vh-100 vw-100">
  <div class="row">
    <div
      class="col-6 vh-100 app-bg-img-half app-bg-mono d-flex justify-content-center align-items-center font-weight-bold"
    >
      <div class="title-container app-title">
        {{ title }}
      </div>
    </div>
    <div
      class="col-6 vh-100 app-bg-mono d-flex flex-column justify-content-center align-items-center"
    >
      <div>
        <div class="content-container" [innerHTML]="body"></div>
        <div class="app-button-container mt-3 align-self-start">
          <app-continue-button
            [route]="route"
            [label]="label"
          ></app-continue-button>
        </div>
      </div>
    </div>
  </div>
</div>
